import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
import IconNote from './vuetify-icons/IconNote.vue'
import IconChair from './vuetify-icons/IconChair.vue'
import IconInhaler from './vuetify-icons/IconInhaler.vue'

Vue.use(Vuetify)

const theme = {
  // primary: '#0f45cd',
  secondary: '#74777a',
  accent: '#0f45cd',
  error: '#e74f24',
  info: '#5fd0d0',
  success: '#1fc151',
  warning: '#f5a623',

  // old agartee
  bodyBg: '#f4f7fc',
  titleText: '#4b6584',

  // new colors
  primary: '#0f45cd',
  white: '#ffffff',
  black: '#343639',
  navy: '#0f45cd',
  darkGrey: '#74777a',
  mediumGrey: '#cfcfd1',
  lightGrey: '#eeeef0',
  coral: '#ff997c',
  orange: '#f5a623',
  green: '#1fc151',
  teal: '#5fd0d0',
  red: '#e74f24',
  burgundy: '#9a3f67',
  lavender: '#8a84c5',
  skyblue: '#65c6ff',
  greyBlue: '#DBE5FF',
  yellow: '#FFE93A',
  actigraphyAwake: '#FFF4A7',
  actigraphySleeping: '#97D7FF',
  actigraphyTransionPeriod: '#D3EEFF',
  actigraphyNoData: '#FFFBDE',
}

const initializeVuetify = () => {
  return new Vuetify({
    theme: {
      themes: {
        light: theme,
      },
    },
    icons: {
      values: {
        // to use these icon, write like <v-icon>$vuetify.icons.customNote</v-icon>
        customNote: { component: IconNote },
        customChair: { component: IconChair },
        customInhaler: { component: IconInhaler },
      },
    },
  })
}

export default initializeVuetify
